/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The list of auth support fields that change is historized:
 *   * VALUE
 *   * TYPE
 *   * PROVIDER
 *   * SECRET_CODE
 *   * INTERNAL_VALUE
 *   * STATE
 *   * VALIDITY_START
 *   * VALIDITY_END
 *   * COMMENT
 *   * SERVICE
 *   * REQUEST_KM
 *   * DIFF_MAX_REQUEST_KM
 *   * LANG_CODE
 *   * REASON
 *   * PARC_NUMBER
 *   * PLATE_NUMBER
 *   * CEILING
 *   * DRIVER_CODE
 *   * SUBSCRIPTION
 *   * MILEAGE_RESET
 *   * STATIONS
 *   * ENERGIES
 */
export enum AuthSupportFieldChange {
  VALUE = 'VALUE',
  TYPE = 'TYPE',
  PROVIDER = 'PROVIDER',
  SECRET_CODE = 'SECRET_CODE',
  INTERNAL_VALUE = 'INTERNAL_VALUE',
  STATE = 'STATE',
  VALIDITY_START = 'VALIDITY_START',
  VALIDITY_END = 'VALIDITY_END',
  COMMENT = 'COMMENT',
  SERVICE = 'SERVICE',
  REQUEST_KM = 'REQUEST_KM',
  DIFF_MAX_REQUEST_KM = 'DIFF_MAX_REQUEST_KM',
  LANG_CODE = 'LANG_CODE',
  REASON = 'REASON',
  PARC_NUMBER = 'PARC_NUMBER',
  PLATE_NUMBER = 'PLATE_NUMBER',
  CEILING = 'CEILING',
  DRIVER_CODE = 'DRIVER_CODE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  MILEAGE_RESET = 'MILEAGE_RESET',
  STATIONS = 'STATIONS',
  ENERGIES = 'ENERGIES'
}
